export const categories = [
  {
    slug: 'nurse',
    name: '护士制服',
    icon: 'ri-heart-pulse-line',
    description: '纯白天使的温柔力量，护士制服以其纯净色彩与专业剪裁，成为最经典的职业制服之一。从传统白色连衣裙到现代医护套装，护士制服承载着治愈与关怀的象征意义。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20nurse%20uniform%20fashion%20photography%20with%20soft%20white%20fabric%20and%20gentle%20lighting%2C%20clean%20medical%20aesthetic%2C%20professional%20yet%20feminine%20style%2C%20studio%20photography%20on%20warm%20cream%20backdrop%2C%20editorial%20quality&width=800&height=600&seq=nurse-cat-01&orientation=landscape',
    articleCount: 8,
  },
  {
    slug: 'flight-attendant',
    name: '空姐制服',
    icon: 'ri-flight-takeoff-line',
    description: '云端之上的优雅典范，空姐制服融合了高端时尚与职业礼仪。各大航空公司的制服设计往往出自顶级设计师之手，展现了不同国家的文化美学与航空品牌的独特气质。',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20flight%20attendant%20uniform%20fashion%20editorial%20with%20elegant%20scarf%20and%20tailored%20suit%2C%20luxurious%20fabric%20texture%2C%20soft%20warm%20lighting%2C%20professional%20aviation%20aesthetic%2C%20clean%20cream%20background%2C%20high%20fashion%20vibe&width=800&height=600&seq=fa-cat-02&orientation=landscape',
    articleCount: 10,
  },
  {
    slug: 'police',
    name: '警察制服',
    icon: 'ri-shield-line',
    description: '正义与力量的形象符号，警察制服以深色调与硬朗线条著称，传递出权威与安全感。从经典深蓝警服到特种作战装备，每一个细节都彰显着执法者的专业与威严。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20police%20uniform%20styled%20fashion%20photography%20with%20dark%20navy%20fabric%20and%20badge%20details%2C%20strong%20silhouette%2C%20dramatic%20yet%20warm%20lighting%2C%20clean%20studio%20background%2C%20editorial%20portrait%20style&width=800&height=600&seq=police-cat-03&orientation=landscape',
    articleCount: 6,
  },
  {
    slug: 'student',
    name: '学生制服',
    icon: 'ri-book-open-line',
    description: '青春与活力的永恒符号，学生制服承载着校园记忆与青春美学。从日式水手服到英伦学院风，不同风格的学生制服展现了多元的青春文化与穿搭哲学。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20school%20uniform%20sailor%20style%20fashion%20photography%20with%20clean%20white%20and%20navy%20fabric%2C%20youthful%20energy%2C%20soft%20natural%20lighting%2C%20warm%20cream%20tone%20background%2C%20editorial%20quality%20portrait&width=800&height=600&seq=student-cat-04&orientation=landscape',
    articleCount: 9,
  },
  {
    slug: 'ol',
    name: 'OL职业装',
    icon: 'ri-briefcase-line',
    description: '都市白领的时尚态度，OL职业装是职场女性的战袍。从经典西装套裙到现代混搭风格，OL制服在专业与时尚之间找到了完美平衡，展现都市女性的自信魅力。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20lady%20professional%20attire%20fashion%20photography%20with%20tailored%20blazer%20and%20pencil%20skirt%2C%20elegant%20neutral%20tones%2C%20soft%20studio%20lighting%2C%20clean%20minimalist%20background%2C%20editorial%20business%20style&width=800&height=600&seq=ol-cat-05&orientation=landscape',
    articleCount: 7,
  },
  {
    slug: 'military',
    name: '军装风格',
    icon: 'ri-medal-line',
    description: '硬朗与纪律的时尚演绎，军装风格以其独特的功能美学影响了整个时尚界。从迷彩元素到双排扣设计，军装制服的经典元素被不断重新诠释，成为街头时尚的重要灵感来源。',
    image: 'https://readdy.ai/api/search-image?query=Military%20uniform%20inspired%20fashion%20photography%20with%20olive%20green%20fabric%20and%20gold%20button%20details%2C%20structured%20silhouette%2C%20warm%20dramatic%20lighting%2C%20clean%20beige%20background%2C%20editorial%20quality&width=800&height=600&seq=military-cat-06&orientation=landscape',
    articleCount: 5,
  },
  {
    slug: 'film-tv',
    name: '影视经典',
    icon: 'ri-film-line',
    description: '荧幕上的制服传奇，无数经典影视作品塑造了令人难忘的制服形象。从日剧学院风到好莱坞超级英雄战衣，影视制服不仅是角色塑造的重要工具，更引领着现实的时尚潮流。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20uniform%20costume%20fashion%20photography%20with%20dramatic%20lighting%20and%20rich%20fabric%20textures%2C%20film%20character%20inspired%20outfit%2C%20warm%20golden%20hour%20tones%2C%20clean%20studio%20backdrop%2C%20editorial%20quality&width=800&height=600&seq=filmtv-cat-07&orientation=landscape',
    articleCount: 8,
  },
  {
    slug: 'cosplay',
    name: '角色扮演',
    icon: 'ri-magic-line',
    description: '二次元到三次元的华丽变身，角色扮演服装将动漫、游戏中的制服美学带入现实。从精心复刻到创意改编，制服cosplay展现了粉丝文化对职业制服的独特理解与热爱。',
    image: 'https://readdy.ai/api/search-image?query=Creative%20cosplay%20uniform%20costume%20fashion%20photography%20with%20detailed%20anime%20inspired%20design%2C%20vibrant%20fabric%20and%20accessories%2C%20warm%20studio%20lighting%2C%20clean%20cream%20background%2C%20editorial%20quality&width=800&height=600&seq=cosplay-cat-08&orientation=landscape',
    articleCount: 6,
  },
];